import React, { useEffect, useState } from 'react';
import { Notifier } from "../ecosystem/";

const LoginPageNotifier = ({
    colorStyle = "alert",
    className = "login-page-notifier",
    children
}) => {

    return (       
            <Notifier colorStyle={colorStyle} className={className}>
                <div className="notifier__message">               
                    {children}
                </div>
            </Notifier>
        
    );
};

export default LoginPageNotifier;